import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { AUDIENCE } from './salesData';
export function AudienceSection() {
  return <section id="para-quien" className="bg-cream py-12 sm:py-16" data-id="element-25" data-mp="s0b9ze2lhbs6">
      <div className="mx-auto max-w-4xl px-5" data-id="element-26" data-mp="wznwfxpk0gu8">
        <div className="text-center" data-id="element-27" data-mp="wycy4devo1ai">
          <SectionTag className="bg-white" data-id="element-28" data-mp="wxbj5xuqquni">Para quién es</SectionTag>
          <h2 className="mx-auto mt-3.5 max-w-[22ch] font-display text-[1.5rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:max-w-[30ch] sm:text-[2.2rem]" data-id="element-29" data-mp="3viwb2035wxbo">
            Si cocinás Keto o Sin TACC, esto te ahorra el problema de todos los días.
          </h2>
        </div>

        <ul className="mt-7 grid gap-2 sm:grid-cols-2" data-id="element-30" data-mp="e1lfm675tq7i">
          {AUDIENCE.map((item, i) => <motion.li key={item.title} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.24,
          ease: [0.23, 1, 0.32, 1],
          delay: Math.min(i, 4) * 0.04
        }} className="flex items-center gap-3 rounded-xl border border-stone bg-white px-3.5 py-3" data-id="element-31" data-mp="3cq0sc12ibfpm" data-mpi={i}>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-gold" data-id="element-32" data-mp="uiwn8gd1hjlo">
                <CheckIcon className="h-4 w-4 text-charcoal" aria-hidden strokeWidth={3} data-id="element-33" data-mp="qhbe963mlpgr" />
              </span>
              <div className="min-w-0" data-id="element-34" data-mp="lhyk00afdg45">
                <h3 className="font-display text-[0.88rem] font-bold leading-tight tracking-tight text-charcoal" data-id="element-35" data-mp="gkyjs609b7ky">
                  {item.title}
                </h3>
                <p className="mt-0.5 font-sans text-[0.8rem] leading-snug text-taupe" data-id="element-36" data-mp="7kjpwi988k5u">
                  {item.desc}
                </p>
              </div>
            </motion.li>)}
        </ul>

        <p className="mx-auto mt-6 max-w-[52ch] text-center font-sans text-[0.86rem] font-medium leading-relaxed text-taupe" data-id="element-37" data-mp="21yucek2cn28g">
          Las más de 500 recetas están disponibles desde el primer día, organizadas por tomo para que
          encuentres rápido qué cocinar en cada momento.
        </p>
      </div>
    </section>;
}